class Snapshot {
  constructor(population) {
    this.population = Object.assign({}, population);
    this.created = new Date();
    this.totalCells = Object.keys(this.population).length;
  }
}

export default Snapshot;



// WEBPACK FOOTER //
// ./src/store/entities/Snapshot.js